<template>
  <a v-bind="computedProps">
    <slot />
  </a>
</template>

<script setup>
const props = defineProps({
	href: {
		type: [String, Object],
		required: true
	}
});

const attrs = useAttrs();

const computedProps = computed(() => {
	return {
		href: props.href,
		...attrs
	};
});
</script>

<style scoped>
a {
  text-decoration: none;
}

.underline {
  text-decoration: underline;
}
</style>
